import React, { useEffect, useState } from 'react';
import { Hero } from '../components/Hero';
import { MeetCindy } from '../components/MeetCindy';
import { Biography } from '../components/Biography';
import { Experiences } from '../components/Experiences';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { ScriptureQuotes } from '../components/ScriptureQuotes';
import { ContactCTA } from '../components/ContactCTA';
import { Footer } from '../components/Footer';
import { BookingModal } from '../components/BookingModal';
const CHECKOUT_URL = 'https://l.instagram.com/?u=http%3A%2F%2Fwa.me%2F17868671817%3Futm_source%3Dig%26utm_medium%3Dsocial%26utm_content%3Dlink_in_bio%26fbclid%3DPAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnaqJ2Sof8kfKpMO62ETPquQzMk-2f5LDvIZ9MIKBRalOfvG9MYpFuYb5DDDE_aem_l3V7ISs1CoqqMmsUrca1pg&e=AT7ythc19Xwk1ZxDZqn7pj_Ell9adPiCk2-P9fqK616cnbmjzxEBcJ8ATXaG_tA4TMS_dwYUCoaPw3TvwftFSgyJXyIwu7Nn4YUvG2aIPQ';
export function LandingPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleBookClick = () => {
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-ivory selection:bg-gold/20 selection:text-softBlack" data-id="element-166">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-2' : 'bg-transparent py-4'}`} data-id="element-167">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-168">
          <a href="#" className="flex-shrink-0" data-id="element-169">
            <img src="https://cdn.magicpatterns.com/uploads/84BS1nTJqoYqvuUwRFjCDh/logo_cindy_S.png" alt="Cindy Salloum - Advanced Skincare" className="h-14 md:h-16 w-auto object-contain" data-id="element-170" />
          </a>
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${isScrolled ? 'bg-gold text-white hover:bg-gold-dark' : 'bg-white/50 backdrop-blur-sm border border-softBlack/10 text-softBlack hover:bg-white'}`} data-id="element-171">
            Agendar cita
          </a>
        </div>
      </nav>

      <main data-id="element-172">
        <Hero onBookClick={handleBookClick} onServicesClick={scrollToServices} data-id="element-173" />
        <MeetCindy onBookClick={handleBookClick} data-id="element-174" />
        <Biography data-id="element-175" />
        <Experiences data-id="element-176" />
        <Services onBookClick={handleBookClick} data-id="element-177" />
        <Testimonials data-id="element-178" />
        <ScriptureQuotes data-id="element-179" />
        <ContactCTA onBookClick={handleBookClick} data-id="element-180" />
      </main>

      <Footer data-id="element-181" />

      {/* Mobile Sticky Button */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-100 md:hidden z-30 flex justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" data-id="element-182">
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="w-full bg-gold text-white font-medium py-3 rounded-full shadow-lg active:scale-95 transition-transform text-center block" data-id="element-183">
          Agendar cita
        </a>
      </div>
    </div>;
}